const init = (select = null, data = null) => {
	let options = {
	    theme: 'bootstrap4',
	    width: '100%'
	};

	if(data){
		options = {
			...options,
		  	data: data
		}
	}

	if(!select){
		select = $('.select2');
	}

	if(select.length){
		select.each(function(){
			let newOption = {
				...options
			};

			const placeholder = $(this).data('placeholder') || $(this).attr('data-placeholder');
			if(placeholder){
				newOption = {
					...newOption,
					placeholder: placeholder
				};
			}

			if($(this).data('tags')){				
				newOption = {
					...newOption,
					tags: true,
					minimumResultsForSearch: 0
				};
			}

			// highlight one " / " separated part of the option text, e.g. the article code
			const highlightPart = $(this).data('highlight-part');
			if(highlightPart > 0){
				const formatHighlightPart = (item) => {
					if(!item || !item.text || item.newTag){
						return item ? item.text : undefined;
					}

					const parts = item.text.split(' / ');
					if(parts.length < highlightPart){
						return item.text;
					}

					const formattedText = $('<span>');
					if(highlightPart > 1){
						formattedText.append(document.createTextNode(`${parts.slice(0, highlightPart - 1).join(' / ')} / `));
					}
					formattedText.append($('<strong>').text(parts[highlightPart - 1]));
					if(parts.length > highlightPart){
						formattedText.append(document.createTextNode(` / ${parts.slice(highlightPart).join(' / ')}`));
					}

					return formattedText;
				};

				newOption = {
					...newOption,
					templateResult: formatHighlightPart,
					templateSelection: formatHighlightPart
				};
			}

			$(this).select2(newOption);			
		});

		// open select2 when focusing on it
		$(document).on('focus', '.select2.select2-container', function (e) {
			// only open on original attempt - close focus event should not fire open
			if (e.originalEvent && $(this).find(".select2-selection--single").length > 0) {
				$(this).siblings('select').select2('open');
			} 
		});
	}
}

export default init;
